/**
 * @description Generates a bulleted list using the material ui List component
 */

import styled from '@mui/system/styled';
import List from '@mui/material/List';

const BulletList = styled(List)(({ theme }) => ({
  paddingBottom: 0,
  paddingLeft: theme.spacing(5),
  paddingTop: 0,
  marginBottom: 0,
  listStyleType: 'disc',

  '& > li': {
    display: 'list-item',
    paddingLeft: 0,

    '&:first-of-type': {
      paddingTop: 0
    }
  }
}));

export default BulletList;
